module.exports = "/assets/9a7dd94d089572b5bc1bb3a2602bd55c.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/HS.png
// module id = 1450
// module chunks = 0